import { useQuery } from '@tanstack/react-query'
import { api } from '@api'

export interface SocialImportItem {
  id: string
  network: string
  username: string
  status: 'pending' | 'running' | 'succeeded' | 'failed' | 'timed_out'
  totalResults: number | null
  createdAt: string | null
}

interface ListSocialImportsResponse {
  imports: SocialImportItem[]
}

const fetchSocialImports = async (): Promise<ListSocialImportsResponse> => {
  const { data } = await api.get<ListSocialImportsResponse>('/ft_import-contacts/list')
  return data
}

export const useFtListSocialImports = (enabled: boolean = true) => {
  return useQuery<ListSocialImportsResponse>({
    queryKey: ['ft_social_imports_list'],
    queryFn: fetchSocialImports,
    enabled,
    refetchInterval: (query) => {
      const imports = query.state.data?.imports
      if (imports?.some((i) => i.status === 'running' || i.status === 'pending')) {
        return 5000
      }
      return false
    },
  })
}
